import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import NavImg from "../../../assets/Dashboard/Footer/logo.webp";
import award from "../../../assets/award.png";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteNewsletter } from "../../../redux/Slices/MainPageSlices/ApiSlice";

const ConfirmationPage = () => {
  const { email } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!email) {
      navigate("/");
    } else {
      dispatch(deleteNewsletter({ email }))
        .unwrap()
        .then(() => {
          toast.success("You have successfully unsubscribed.");
        })
        .catch(() => {
          toast.error("Failed to unsubscribe. Please try again.");
        });
    }
  }, [email, navigate, dispatch]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-between bg-white">
      <header className="w-full text-center py-4 bg-white shadow-md">
        <img src={NavImg} alt="Logo" className="mx-auto h-12" />
      </header>

      <main className="flex-grow flex flex-col items-center justify-center px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          You’ve Unsubscribed
        </h1>
        <img src={award} alt="Confirmation Icon" className="mb-6 h-32" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          You have been removed from our list.
        </h1>
        <p className="text-gray-600 text-center mb-6">
          You will no longer receive our newsletters. If this was a mistake, you
          can re-subscribe anytime.
        </p>
        <button
          onClick={() => navigate("/")}
          className="px-6 py-3 bg-background hover:bg-hover text-white rounded-lg font-semibold focus:outline-none"
        >
          Go to Home
        </button>
      </main>

      <footer className="w-full bg-gray-100 py-6 text-center text-sm text-gray-500">
        <p>Copyright ©2022 ExactMail.io. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ConfirmationPage;
